<div class="d-flex justify-content-center align-items-center" style="min-height: 100vh;">
    <mat-spinner></mat-spinner>
</div>
